
import TableListHead from "./TableListHead.vue";
import TableListFoot from "./TableListFoot.vue";
import TableListAim from "./TableListAim.vue";
import TableListCriterion from "./TableListCriterion.vue";
import TableListAlternative from "./TableListAlternative.vue";

import { sortBy } from "lodash";

import { setStickyTable, handleStickyTableResize } from "./TableList";

import {
  clearAppFilters,
  subOptionsIds,
  alternativesIds,
  criterionsIds,
  c_criterionsIds,
  aimsIds,
  getAimsBy,
  getAlternatives,
  getSubOptions,
  state,
  getFilteredCriterions,
  getFilteredItems,
  getFilteredAims,
} from "@/store";
import { computed, defineComponent } from "vue";

export default defineComponent({
  setup() {
    return {
      state,

      sortBy,
      getAimsBy,
      setStickyTable,
      handleStickyTableResize,
      clearAppFilters,

      c_criterionsIds,

      getFilteredCriterions: computed(() => getFilteredCriterions()),
      subOptionsIds: computed(() => subOptionsIds()),
      alternativesIds: computed(() => alternativesIds()),
      criterionsIds: computed(() => criterionsIds()),
      aimsIds: computed(() => aimsIds()),
      getAlternatives: computed(() => getAlternatives()),
      getSubOptions: computed(() => getSubOptions()),
      getFilteredItems,
      getFilteredAims: computed(() => getFilteredAims()),
      project: computed(() => state.project),
    };
  },

  mounted() {
    this.$nextTick(setStickyTable);
  },
  created() {
    window.addEventListener("resize", this.handleStickyTableResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleStickyTableResize);
  },
  watch: {
    // project() {
    //   this.$forceUpdate();
    //   setStickyTable();
    // }
  },

  components: {
    TableListCriterion,
    TableListHead,
    TableListFoot,
    TableListAlternative,
    TableListAim,
  },
});
